import type { NextPage } from 'next'
import styles from '../../styles/ComponentHeader.module.scss'

interface Props {
  title: string
  buttonText?: string
  buttonOnClick?: any
}
const ComponentHeader: NextPage<Props> = (props: Props) => {
  return (
    <div className={styles.component_header}>
      <div className={styles.title_wrapper}>{props.title}</div>
      {props.buttonText && (
        <div className={styles.view_all_wrapper} onClick={props.buttonOnClick}>
          {props.buttonText}
        </div>
      )}
    </div>
  )
}

export default ComponentHeader
